module.exports = __webpack_public_path__ + "img/chinesecompany160.d15f2799.png";